<template>
  <Modal :id="'cmp-catalog-release-documents-modal'" @cancelled="onCancel">
    <template slot="header">{{ $t("submenu_Templates") }}</template>
    <template slot="body">
      <div class="ut-flex ut-alstart">
        <SearchList
          :id="'document_templates'"
          :items="templateList"
          :keyProperty="'booking_template_id'"
          :label="'booking_template_name'"
          :selected="selectedTemplateSet"
          @selected="onTemplateSelected"
          :selectionNumber="'single'"
          :isSearchable="false"
        />
        <HtmlDocPro
          ref="htmlDocPro"
          :documentName="selectedTemplateName"
          :htmlData="selectedTemplate || ''"
          @download="onDownload"
          @input="onHtmlDataInput"
          style="margin-right: 0px"
        />
        <!-- <div class="html-document"> -->
        <!-- <HtmlEditor v-model="selectedTemplate"></HtmlEditor> -->
        <!-- </div> -->
      </div>
    </template>
    <template slot="options">
      <button
        style="margin-right: 20px"
        class="dt-button s6"
        @click="onCopyAsXLSX"
      >
        {{ $t("copy_as_xlsx") }}
      </button>
      <button
        style="margin-right: 20px"
        class="dt-button s6"
        @click="onExportAsCSV"
      >
        {{ $t("export_as_csv") }}
      </button>
      <button
        style="margin-right: 20px"
        class="dt-button s6"
        @click="onDownload"
      >
        {{ $t("open_in_new_tab_string") }}
      </button>
      <button class="dt-button s6" @click="onCancel">{{ $t("cancel") }}</button>
      <button class="dt-button v1 s6" @click="onPDFDownload">
        {{ $t("download_as_pdf") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";
import {
  createHttpGetOptions,
  getBaseUrl,
  MHTTPCL,
} from "../../services/http/http-client";
import SearchList from "@dtplugins/search-list/search-list";
import HtmlEditor from "@plugins/html-editor/html-editor";
import HtmlDocPro from "@plugins/html-doc-pro/html-doc-pro";
import { DTTemplateAPI } from "./dt-template.api";
import { LABEL_URL } from "../../services/common-urls";

export default {
  props: {},
  components: {
    SearchList,
    Modal,
    HtmlEditor,
    HtmlDocPro,
  },
  data: function () {
    return {
      templateList: [],
      selectedTemplate: null,
      selectedTemplateId: null,
    };
  },
  mounted: async function () {
    // console.log(this.$route);

    this.templateList = await DTTemplateAPI.findTemplateList(
      findModule(this.$route)
    );

    // Select First Template by Default
    this.selectedTemplateId = this.templateList?.[0].booking_template_id;
    // console.log({
    //   "dt-template-list.vue:70 this.selectedTemplateId":
    //     this.selectedTemplateId,
    // });
  },
  computed: {
    external_id: function () {
      return this.$route.query.external_id;
    },
    selectedTemplateSet: function () {
      return new Set([this.selectedTemplateId]);
    },
    selectedTemplateName: function () {
      return (
        this.templateList?.find(
          (template) =>
            template?.booking_template_id === this.selectedTemplateId
        )?.booking_template_name || "Template"
      );
    },
  },
  methods: {
    async onTemplateSelected(selected) {
      if (!Array.from(selected)[0]) {
        return;
      }
      this.selectedTemplateId = Array.from(selected)[0];
      this.selectedTemplate = null;

      // console.log({
      //   "dt-template-list.vue:99 this.selectedTemplateId":
      //     this.selectedTemplateId,
      // });
      this.selectedTemplate = await DTTemplateAPI.getTemplateText(
        findModule(this.$route),
        this.selectedTemplateId
      );
      // console.log({
      //   "dt-template-list.vue:94 this.selectedTemplateId":
      //     this.selectedTemplateId,
      //   selectedTemplate: this.selectedTemplate,
      // });
    },
    async onDownload() {
      // Call the Method onDownload in Component htmlDocPro
      this.$refs.htmlDocPro.openInNewTab();

      // let url =
      //   `${getBaseUrl()}${LABEL_URL}?section=releases&action=render_release_template&` +
      //   `release_id=${this.external_id}&` +
      //   `booking_template_id=${this.selectedTemplateId}`;

      // window.open(url, "_blank");
      // console.log({ "documents-modal.vue:109 url": url });
    },
    async onCopyAsCSV() {
      this.$refs.htmlDocPro.copyAsCSV();
    },
    async onCopyAsXLSX() {
      this.$refs.htmlDocPro.copyAsXLSX();
    },
    async onExportAsCSV() {
      this.$refs.htmlDocPro.exportAsCSV();
    },
    async onPDFDownload() {
      this.$refs.htmlDocPro.onDownloadPDF();
    },
    onHtmlDataInput(value) {
      // console.log({ "documents-modal.vue:117 value Length": value?.length });
      this.selectedTemplate = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};

function findModule(route) {
  const url = route.path;
  const parts = url.split("/").filter(Boolean);
  const moduleIndex = parts.indexOf("main");

  if (moduleIndex === -1) {
    return { module: null, submodule: null };
  }

  const module = parts[moduleIndex + 1] || null;
  const submodule = parts[moduleIndex + 2] || null;

  const external_id = route.query.external_id;

  return { module, submodule, external_id };
}
</script>

<style lang="scss" scoped>
.dt-table2.search-list {
  min-width: 267.5px;
}
.dt-table2.search-list .dt-table2--row.selected {
  background: hsl(0, 0%, 88%);
}
</style>